import { LANGUAGES_COLLECTION, SEARCH } from '../coaching-core.tokens';
import { Language } from '../models/enums';
import * as searchConstants from '../constants/search.constant';
import { Provider } from '@angular/core';

export function provideConstants(): Provider[] {
  return [
    {
      provide: LANGUAGES_COLLECTION,
      useValue: {
        [Language.EN]: {
          label: 'common_language_english',
          value: Language.EN,
        },
        [Language.NL]: {
          label: 'common_language_dutch',
          value: Language.NL,
        },
        [Language.TR]: {
          label: 'common_language_turkish',
          value: Language.TR,
        },
        [Language.ES]: {
          label: 'common_language_spanish',
          value: Language.ES,
        },
        [Language.DE]: {
          label: 'common_language_german',
          value: Language.DE,
        },
        [Language.SV]: {
          label: 'common_language_swedish',
          value: Language.SV,
        },
        [Language.RO]: {
          label: 'common_language_romanian',
          value: Language.RO,
        },
      },
    },
    {
      provide: SEARCH,
      useValue: searchConstants,
    },
  ];
}
